import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  Badge,
  Label,
  Button,
} from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import AdminHeader from "components/Headers/AdminHeader";
import { urlDecodedId } from "components/CommonComponents/encodeDecodeFunction";

const initialFields = {
  fullName: {
    value: "Jane Smith",
    error: "",
  },
  email: {
    value: "jane.smith@example.com",
    error: "",
  },
  phone: {
    value: "9876543210",
    error: "",
  },
  experienceYears: {
    value: "5 years & 2 month",
    error: "",
  },
  gender: { value: "Female", error: "" },
  skills: {
    value: ["Cable Jointing", "Substation Maintenance"],
    error: "",
  },
  status: { value: "ACTIVE", error: "" },
};

function InstructorDetails() {
  const authData = JSON.parse(localStorage.getItem("p") || "{}");
  const role = authData?.role;
  const { id } = useParams();
  const decodedId = id ? urlDecodedId(id) : null;
  const [data] = useState(initialFields);
  const navigate = useNavigate();

  useEffect(() => {
    if (decodedId) {
    }
  }, [decodedId]);
  return (
    <>
      <AdminHeader />

      <Container fluid className="mt--6">
        {/* Header */}
        <Row className="justify-content-center">
          <Col md="12">
            <Card>
              <CardHeader className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <i
                    className="fa fa-chevron-left mr-2 cursor"
                    onClick={() =>
                      navigate(
                        role === "SUPER_ADMIN"
                          ? "/super-admin/instructor"
                          : "/admin/instructor",
                      )
                    }
                  />
                  <h3 className="mb-0">Trainer Details</h3>
                </div>
                <Button
                  className="btn-deep-blue"
                  onClick={() =>
                    navigate(
                      role === "SUPER_ADMIN"
                        ? "/super-admin/instructor/add-new"
                        : "/admin/instructor/add-new",
                      {
                        state: { mode: "edit" },
                      },
                    )
                  }
                >
                  <i className="fa fa-pencil mr-1" />
                  Edit
                </Button>
              </CardHeader>
            </Card>
          </Col>
        </Row>

        <Row className="mt-3">
          {/* LEFT */}
          <Col md="6">
            <Card className="h-100">
              <CardHeader>
                <h4 className="mb-0">Basic Information</h4>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col md="6">
                    <div className="mb-3 d-flex flex-column align-items-start ">
                      <Label className="small-label text-muted mb-1">
                        Name
                      </Label>
                      <div className="small-text">{data.fullName.value}</div>
                    </div>
                  </Col>

                  <Col md="6">
                    <div className="mb-3 d-flex flex-column align-items-start ">
                      <Label className=" small-label text-muted mb-1">
                        Email
                      </Label>
                      <small className="small-text">{data.email.value}</small>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col md="6">
                    <div className="mb-3 d-flex flex-column align-items-start ">
                      <Label className="small-label text-muted mb-1">
                        Mobile Number
                      </Label>
                      <div className="small-text">{data.phone.value}</div>
                    </div>
                  </Col>

                  <Col md="6">
                    <Label className="small-label text-muted mb-1">
                      Status
                    </Label>
                    <div>
                      <Badge
                        color={
                          data.status.value === "ACTIVE"
                            ? "success"
                            : "secondary"
                        }
                        className="badge-lg"
                      >
                        {data.status.value}
                      </Badge>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>

          {/* RIGHT */}
          <Col md="6">
            <Card className="h-100">
              <CardHeader>
                <h4 className="mb-0">Professional Information</h4>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col md="6">
                    <div className="mb-3">
                      <Label className="small-label text-muted mb-1">
                        Experience Year
                      </Label>
                      <div className="small-text">
                        {data.experienceYears.value}
                      </div>
                    </div>
                  </Col>

                  <Col md="6">
                    <div className="mb-3">
                      <Label className="small-label text-muted mb-1">
                        Gender
                      </Label>
                      <div className="small-text">{data.gender.value}</div>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col md="12">
                    <Label className="small-label text-muted mb-1">
                      Skills
                    </Label>

                    {data.skills.value.length ? (
                      <ol className="pl-3 mt-1 mb-0">
                        {data.skills.value.map((skill, index) => (
                          <li key={index} className="small-text mb-1">
                            {skill}
                          </li>
                        ))}
                      </ol>
                    ) : (
                      <small className="text-muted">No skills added</small>
                    )}
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default InstructorDetails;
